export default __webpack_public_path__ + "static/media/regulatory--no-pedestrians--g3.db9ef7ad.png";